export const testAttributes = {
    MODAL_ALERT_CONTAINER: 'modal_alert_container',
};

export const defaultAttributes = {
    LABEL_BTN: 'I FORGIVE YOU',
    CONTENT_MESSAGE: 'Sorry, we were unable to fetch your results',
};